import { AttachmentFiles } from './AttachmentFiles'
import { HeroContentHigh } from './HeroContentHigh'
import { SavedContent } from './SavedContent'

export default { HeroContentHigh, AttachmentFiles, SavedContent }
